import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=567ab15d&scoped=true"
import script from "./LabelView.vue?vue&type=script&lang=js"
export * from "./LabelView.vue?vue&type=script&lang=js"
import style0 from "./LabelView.vue?vue&type=style&index=0&id=567ab15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ab15d",
  null
  
)

export default component.exports